// HOOKS
import { useMutation } from "@apollo/client";
// GRAPHQL
import { CREATE_PRODUCTS } from "../../graphql/mutations/products/products.mutations";

const useCreateManyProducts = () => {
  const [createManyProductsMutation, { data, loading, error }] =
    useMutation(CREATE_PRODUCTS);

  const createManyProducts = (products) => {
    return createManyProductsMutation({ variables: { products } });
  };

  return { createManyProducts, data, loading, error };
};

export default useCreateManyProducts;
